//@ts-nocheck

import styled, { css } from 'styled-components'
import { Paragraph, Heading } from '../../atoms/Typography/Typography.styles'

interface NavScrollbarProps {
  isComparison?: boolean
}

interface SwiperWrapperProps {
  isComparison?: boolean
}

interface CarouselCardsProps {
  inset?: boolean
  colorScheme?: string
  cardSeparator?: boolean
  withBackground?: boolean
}

interface CarouselCardsButtonProps {
  isItemsMoreThanThree?: boolean
}

export const NavScrollbar = styled.div<NavScrollbarProps>`
  width: 100%;
  height: 4px;

  ${({ theme, isComparison }) => isComparison && theme.mediaQuery.md`
    margin-top: ${theme.rem(24)};
  `}
`

export const SwiperWrapper = styled.div<SwiperWrapperProps>`
  position: relative;

  .swiper-wrapper {
    transition: all ease 0.3s;

    .swiper-slide {
      padding-top: ${({ theme }) => theme.rem(8)};
      height: auto !important;

      ${({ type }) => type === 'CardCertification' && css`
        height: 100% !important;
      `}
    }
  }
`

export const CarouselCards = styled.div<CarouselCardsProps>`
  width: 100%;
  // background-color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.inside};

  ${({ theme, colorScheme }) => css`
    ${NavScrollbar} {
      background-color: ${theme.colorScheme[`${colorScheme}`].surface.inside};

      .swiper-scrollbar-drag {
        background-color: ${theme.colorScheme[`${colorScheme}`].surface.outside};
      }
    }
  `}

  ${SwiperWrapper} {
    .swiper-wrapper {
      // ${({ theme, inset }) => !inset && css`
      //     padding-top: ${theme.rem(16)};
      //     padding-bottom: ${theme.rem(16)};

      //     ${theme.mediaQuery.lg(`
      //     padding-top: ${theme.rem(24)};
      //     padding-bottom: ${theme.rem(24)};
      //   `)}
      // `}
    }
  }

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[colorScheme].surface.text.base.negative : theme.colorScheme[colorScheme].surface.text.base.primary};
  }
`

export const CarouselCardsTexts = styled.div`
  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[colorScheme].surface.text.base.negative : 'black'};
  }
`

export const Navigation = styled.div`
  width: 100%;
  padding-top: ${({ theme }) => theme.rem(32)};
  gap: ${({ theme }) => theme.rem(16)};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const NavigationButton = styled.div`
  position: relative;
  left: auto;
  transform: translateY(0);
  z-index: 1;

  button {
    width: ${({ theme }) => theme.rem(46)};
    height: ${({ theme }) => theme.rem(46)};
    padding: 0!important;

    &:first-of-type {
      margin-left: 0;
    }

    &.swiper-button-lock {
      display: none;
    }
  }
`

export const ButtonPrev = styled(NavigationButton)`
  left: 0;
`

export const ButtonNext = styled(NavigationButton)`
  right: 0;
`

export const CarouselCardsButton = styled.div<CarouselCardsButtonProps>`
  width: 100%;
  display: flex;
  justify-content: center;

  ${({ isItemsMoreThanThree }) =>
    isItemsMoreThanThree &&
    css`
      margin-top: ${({ theme }) => theme.rem(24)};

      ${({ theme }) => theme.mediaQuery.lg`
      margin-top: ${theme.rem(40)};
    `}
  `}
`
